module.exports = __webpack_public_path__ + "static/media/XL.3ef0db92.jpg";